import { useContext, useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import LayoutEditor from "../../components/LayoutEditor/Index";
import Visualizer from "../../components/Visualizer/Index";
import { Store } from "../../store";
import "./Home.css";

import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//API
import axios from "../../service/axios";

//Helper Functions
import { transformElements } from "../../utils/helpers";

import ViewModeToggle from "../../components/Switch/ViewModeToggle";
import { VIEW_MODES } from "../../components/Switch/view-modes.config";

const Home = () => {
  const {
    state: { viewportMode, elements },
    dispatch,
  } = useContext(Store);
  const isViewPortMode2d = viewportMode && viewportMode === "2d";
  const [loading, setLoading] = useState(false);
  const [layoutName, setlayoutName] = useState(() => localStorage.getItem("layoutName") || "");
  const fetchLayoutObjects = async () => {
    //setLoading(true);
    const { search } = location;
    const queryParams = new URLSearchParams(search);
    const layoutId = queryParams.get("layoutId");

    try {
      const { data } = await axios.get(`layout-objects/${layoutId}`);
      const responseData = data?.data;
      if (!responseData.length) return;
      const elements = transformElements(responseData);
      // batch dispatch
      dispatch({
        type: "BATCH_DISPATCH",
        payload: [
          { type: "SET_ELEMENTS", payload: elements },
          { type: "SET_INITIAL_LOAD", payload: true },
        ],
      });
    } catch (error) {
      // const {
      //   response: {
      //     data: { message },
      //   },
      // } = error;
      // const defaultErrorMessage = "Oops Something went wrong";
      // toast.error(message || defaultErrorMessage);
      console.log("error", error);
    } finally {
      //setLoading(false);
      dispatch({ type: "HIDE_GLOBAL_LOADER" });
    }
  };

  const get3dHeaderActions = () => {
    return (
      <>
        <ViewModeToggle />
      </>
    );
  };

  const renderViewPortMode = (viewPortMode) => {
    switch (viewPortMode) {
      case "2d":
        return <LayoutEditor fetchLayoutObjects={fetchLayoutObjects} />;
      case "3d":
        return (
          <Visualizer
            header={
              <Header title={layoutName + " 3D View"} actions={get3dHeaderActions()} backHandler={<FontAwesomeIcon icon={faArrowLeft} className="back-arrow" />} />
            }
            fetchLayoutObjects={fetchLayoutObjects}
          />
        );
      default:
        return;
    }
  };

  useEffect(() => {
    const savedMode = localStorage.getItem("viewportMode") || "2d";
    const selected = VIEW_MODES.find((m) => m.value === savedMode);

    dispatch({
      type: "BATCH_DISPATCH",
      payload: [
        { type: "SET_VIEWPORT_MODE", payload: savedMode },
        {
          type: "SHOW_GLOBAL_LOADER",
          payload: {
            isActive: true,
            loaderText: selected?.loaderText || "Initializing View...",
          },
        },
      ],
    });

    fetchLayoutObjects();
  }, []);

  return (
    <div>
      <div className="main">
        <div className="container">
          <div className="content">
            <div className="container-inner">{renderViewPortMode(viewportMode)}</div>
          </div>
        </div>
      </div>
      {/* {loading && <Loader />} */}
    </div>
  );
};

export default Home;
